import type { MathflatApi } from '@mathflat/domain/@entities/StudentWorksheet/api2'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '../utils/maxios'

export const studentWorksheetApi = (() => {
  return {
    getStudentWorksheetWithHomeworks: (
      studentId: string,
      params: {
        startDate: string
        endDate: string
      },
    ) =>
      maxios.get<DefaultResponse<MathflatApi.Response.StudentWorksheet[]>>(
        `/student-worksheet/${studentId}/homeworks`,
        {
          params,
        },
      ),
  }
})()
